<template>
  <div class="modal is-active">
    <div class="modal-background" v-on:click="closeModule"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Add Your Own Module</p>
        <button class="delete" aria-label="close" v-on:click="closeModule"></button>
      </header>
      <section class="modal-card-body">
        <div class="content">
        <p>If you use GoNoodle or any other type of physical activity that isn't included with I-CAN!, let us know about it by entering it here. Once added, you can schedule it like any other module. <strong>Note that only you will see the modules you add.</strong></p>
        </div>
        <article class="message is-success" v-if="showThanks">
          <div class="message-header">
            <p>Thank you!</p>
            <button class="delete" aria-label="delete" v-on:click="hideThanks()"></button>
          </div>
          <div class="message-body">Your module was successfully added! Only you will be able to view and schedule your modules.</div>
        </article>
        <div class="field">
          <label class="label">Title</label>
          <div class="control">
            <textarea class="input" placeholder="Module Title" v-model="title"></textarea>
          </div>
        </div>
        <div class="field">
          <label class="label">Description</label>
          <div class="control">
            <textarea class="textarea" placeholder="Module Description" v-model="description"></textarea>
          </div>
        </div>
        <div class="control">
          <button
            class="button is-link"
            :disabled="description==null || description==''"
            v-on:click="submit()"
          >Submit</button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "ModuleForm",
  data() {
    return {
      title: null,
      description: null,
      showThanks: false
    };
  },
  methods: {
    submit: async function() {
      const body = { title: this.title, description: this.description };
      const config = this.$store.getters.config;
      const url = `${process.env.VUE_APP_API_URL}module`;
      axios.post(url, body, config).then(response => {
        if (response) {
          this.title = null;
          this.description = null;
          this.showThanks = true;
          this.$emit("newModule");
          this.logAction("add_module",body)
        }
      });
    },
    hideThanks: function() {
      this.showThanks = false;
    },
    closeModule: function(){
      this.$emit("closeModule")
    },
    logAction: async function(action, note) {
      const body = {
        action,
        note:JSON.stringify(note)
      };
      const config = this.$store.getters.config;
      await axios.post(`${process.env.VUE_APP_API_URL}log`, body, config);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>